import { jsx } from 'react/jsx-runtime';
import { Elements } from '../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.js';
import { loadStripe } from '../../node_modules/@stripe/stripe-js/dist/pure.esm.js';
import cjs from '../../node_modules/deepmerge/dist/cjs.js';
import { useState } from 'react';
import { useTheme } from '../../utils/hooks/use-theme.js';
import { getStripeStyles, Wrapper } from './payment-method-form-with-microdeposits.style.js';
import { Stripe } from './stripe.component.js';

const defaultCopy = {
    cancel: 'Cancel',
    submit: 'Add payment method',
    error: "We're having trouble loading this input. Try refreshing the page or checking your network connection.",
};
const PaymentMethodFormWithMicrodeposits = ({ children, className = '', copy: _copy = defaultCopy, disabled = false, loading = false, onCancel, onReady, onSubmit, paymentMethodOrder, parseError, redirectUrl, stripeClientSecret, stripeKey, locale, }) => {
    var _a;
    const theme = useTheme();
    const copy = cjs(defaultCopy, _copy);
    const [stripePromise] = useState(() => loadStripe(stripeKey));
    const supportedLocales = ['es', 'en'];
    const stripeProps = {
        copy,
        disabled,
        loading,
        onCancel,
        onReady,
        onSubmit,
        parseError,
        redirectUrl,
        paymentMethodOrder,
    };
    const appearance = getStripeStyles(theme);
    const stripeLocale = (_a = supportedLocales.find(supportedLocale => supportedLocale === locale)) !== null && _a !== void 0 ? _a : 'auto';
    return (jsx(Wrapper, Object.assign({ className: className }, { children: jsx(Elements, Object.assign({ stripe: stripePromise, options: {
                appearance,
                locale: stripeLocale,
                clientSecret: stripeClientSecret,
                fonts: [
                    {
                        cssSrc: 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap',
                    },
                ],
            } }, { children: jsx(Stripe, Object.assign({}, stripeProps, { children: children }), void 0) }), void 0) }), void 0));
};

export { PaymentMethodFormWithMicrodeposits, defaultCopy };
